module.exports = __webpack_public_path__ + "static/media/help-circle.60415ebd.svg";